import React from 'react';
import {connect} from 'react-redux';
import * as classnames from 'classnames';
import './thermostat-ext-modes-control.sass';
import '../../../../mui/tumbler';
import {DeviceThermometersView} from '../../../tabs/legacy/state/components/thermometers-view';
import {BoilerFailPane} from '../../../tabs/legacy/state/components/boiler-fail-pane';
import {ButtonBox} from '../../../dialogs/dialogs';
import Tumbler from '../../../react-elements/tumbler';
import {LegacyDevice} from '../../../device/device';
import {LongPressButton} from './longpress';
import {formatTemp} from '../../../../utils';
import {MessageBox} from '../../../shared/components/dialogs/message-box';
import {
    requestDeviceUpdate,
    requestThermostatZoneTemps,
} from '../../../redux/devices/items/actions';
import {Flame} from './flame-icon';
import {Tooltip} from '@mui/material';
import {selectDevice, selectSelectedDevice} from '../../../entities/device/lib';
import {Capability} from '../../../device/device-capability';

export const ThermostatExtModeButton = ({
    name,
    zone_temp,
    schedule_number,
    selected,
    gate_mode,
    show_temp = true,
    onClick,
}) => (
    <LongPressButton
        enabled={true}
        onClick={onClick}
        className={classnames('ui-thermostat-control-mode', {
            selected: selected,
            'gate-mode': gate_mode,
            'longpress-cyan': selected,
        })}
    >
        <div className="ui-thermostat-control-mode-title">{name}</div>
        {show_temp && (
            <div className="ui-thermostat-control-mode-temp">
                {zone_temp?.[1] === false
                    ? 'откл'
                    : [null, undefined, 'reserve', 'on'].includes(zone_temp?.[1])
                    ? '\xa0'
                    : schedule_number != null
                    ? '\xa0'
                    : formatTemp(zone_temp?.[1])}
            </div>
        )}
    </LongPressButton>
);

const ThermostatExtModesControlImpl = ({
    thermostat_ext_modes_config,
    thermostat_ext_mode,
    thermostat_gate_available,
    thermostat_gate,
    ot_enabled,
    ot_config,
    ot_show_dhw_control,
    onModeChanged,
    onGateChanged,
    onDHWChanged,
}) => {
    const config = thermostat_ext_modes_config ?? {};

    const button_props = Object.entries(config)
        .filter(([_mode_id, mode_spec]) => mode_spec?.active && !mode_spec?.hidden)
        .map(([mode_id, mode_spec]) => {
            mode_id = parseInt(mode_id, 10);
            return {
                key: mode_id,
                selected: thermostat_ext_mode === mode_id,
                gate_mode: !!thermostat_gate,
                onClick: () => onModeChanged?.(mode_id),
                ...mode_spec,
            };
        });

    button_props.sort((a, b) => {
        if (a.key > b.key) return +1;
        if (a.key < b.key) return -1;
        return 0;
    });

    const buttons = button_props.map((props) => (
        <ThermostatExtModeButton key={props.key} {...props} />
    ));

    const show_gate = thermostat_gate_available;
    const show_dhw = ot_enabled && ot_config != null && ot_show_dhw_control;

    return (
        <div className="ui-card ui-thermostat-control-modes">
            <h1 style={{textAlign: 'left'}}>Режим</h1>
            {buttons}
            <div className="ui-thermostat-control-tumblers">
                <span
                    className={classnames(
                        'ui-thermostat-control-tumbler',
                        'ui-thermostat-control-gate',
                        {visible: show_gate}
                    )}
                >
                    <Tumbler
                        text_on="Комнатный термостат"
                        text_off="Комнатный термостат"
                        checked={!!thermostat_gate}
                        onChange={(checked) =>
                            typeof onGateChanged === 'function'
                                ? onGateChanged(checked)
                                : undefined
                        }
                    />
                </span>

                <span
                    className={classnames(
                        'ui-thermostat-control-tumbler',
                        'ui-thermostat-control-dhw',
                        {visible: show_dhw}
                    )}
                >
                    <Tumbler
                        text_on="Горячая вода"
                        text_off="Горячая вода"
                        checked={show_dhw && ot_config.includes('dhw')}
                        onChange={(checked) =>
                            typeof onDHWChanged === 'function'
                                ? onDHWChanged(checked)
                                : undefined
                        }
                    />
                </span>
            </div>
        </div>
    );
};

const ThermostatExtModesControl = connect((state, {device_id}) => {
    const r_device = selectDevice(state, device_id);

    return {
        thermostat_ext_modes_config: r_device.thermostat_ext_modes_config,
        thermostat_ext_mode: r_device.thermostat_ext_mode,
        thermostat_gate_available: LegacyDevice.thermostat_gate_available(r_device),
        thermostat_gate: r_device.thermostat_gate,
        ot_enabled: r_device.ot_enabled,
        ot_config: r_device.ot_config,
        ot_show_dhw_control: r_device.ot_show_dhw_control,
    };
})(ThermostatExtModesControlImpl);

export const TargetTemp = ({
    head_title,
    is_fail,
    adjustable,
    name,
    color,
    target_therm_name,
    spec,
    flame,
    snow,
    has_pza,
    summer_mode,
    current_temp,
    zone_settings,
    temp_warn_dec,
    temp_warn_inc,
    onIncDecClick,
    onCascadeSelect,
}) => (
    <div className={classnames('thermostat-target-temp', {alarm: is_fail})}>
        {color != null && (
            <div
                style={{border: '4px solid ' + (color ? color : 'gray')}}
                title={head_title}
            />
        )}

        <div className="thermostat-target-temp-padding">
            <div
                className="thermostat-target-temp-row"
                style={{display: 'flex', flexFlow: 'row nowrap'}}
            >
                <div className="thermostat-target-temp-title" title="целевой датчик">
                    {target_therm_name}
                </div>
                <div className="thermostat-target-temp-title-value">
                    <span style={{marginLeft: '1em'}} title="температура датчика">
                        {formatTemp(current_temp)}
                    </span>
                </div>
                <div style={{flexGrow: '0', flexShrink: '0', marginLeft: '1em'}}>
                    {flame && (
                        <Tooltip title="Нагрев">
                            <span>
                                <Flame flame={true} width={12} height={12} />
                            </span>
                        </Tooltip>
                    )}
                    {snow && (
                        <div className="thermostat-control-snow" title="охлаждение" />
                    )}
                    {has_pza && !summer_mode && (
                        <div className="thermostat-control-pza" title="ПЗА" />
                    )}
                    {summer_mode && (
                        <div
                            className="thermostat-control-summer-mode"
                            title="Летний режим"
                        />
                    )}
                </div>
            </div>

            <div className="thermostat-target-temp-row thermostat-target-temp-row-bottom">
                {adjustable && (
                    <div
                        className={classnames(
                            'thermostat-target-temp-incdec thermostat-target-temp-dec',
                            {warn: temp_warn_dec != null}
                        )}
                        onClick={temp_warn_dec ? () => {} : () => onIncDecClick(-1)}
                        title={temp_warn_dec ? temp_warn_dec : 'уменьшить температуру'}
                    />
                )}
                <div className="thermostat-target-temp-target">
                    <span
                        title={spec.title}
                        style={{color: spec.temp_violation ? '#c4443b' : undefined}}
                    >
                        {(zone_settings?.flags ?? []).includes('boiler') &&
                        (spec.cascade != null || spec.off) ? (
                            <select
                                value={spec.off ? 'off' : spec.cascade}
                                className="thermostat-target-temp-cascade"
                                onChange={(event) =>
                                    onCascadeSelect(event.target.value)
                                }
                            >
                                <option value="off">отключен</option>
                                <option value="reserve">резерв</option>
                                {!spec.off && spec.cascade === 'reserve_on' && (
                                    <option value="reserve_on">резерв (вкл)</option>
                                )}
                                <option value="on">включен</option>
                            </select>
                        ) : spec.off ? (
                            'откл'
                        ) : spec.cascade === 'reserve' ? (
                            'резерв'
                        ) : spec.cascade === 'reserve_on' ? (
                            'резерв (вкл)'
                        ) : spec.cascade === 'on' ? (
                            'вкл'
                        ) : typeof spec.temp == 'number' ? (
                            `${spec.temp.toFixed(1)}°`
                        ) : (
                            '??'
                        )}
                    </span>
                    {spec.manual && (
                        <div
                            className="thermostat-target-temp-manual ui-icon-thermostat-control-mode-manual"
                            title="температура изменена вручную"
                        />
                    )}
                </div>
                {adjustable && (
                    <div
                        className={classnames(
                            'thermostat-target-temp-incdec thermostat-target-temp-inc',
                            {warn: temp_warn_inc != null}
                        )}
                        onClick={temp_warn_inc ? () => ({}) : () => onIncDecClick(+1)}
                        title={temp_warn_inc ? temp_warn_inc : 'увеличить температуру'}
                    />
                )}
            </div>
        </div>
        {name != null && (
            <div
                className="thermostat-target-temp-zone-name"
                style={{
                    backgroundColor: color ? color : undefined,
                    color: color ? 'white' : undefined,
                }}
                title={head_title}
            >
                {name}
            </div>
        )}
    </div>
);

class TargetTempsControlImpl extends React.Component {
    target_therm_name(zone_no, zone_count) {
        const thermometer = this.control_thermometer(~~zone_no);
        if (~~zone_no === 0) return 'Горячая вода';
        else if (thermometer != null) return thermometer.name;
        else if (this.props.thermostat_zones_settings?.[zone_no]?.name != null) {
            if (zone_count === 2) return 'Отопление';
            return `Отопление №${zone_no}`;
        }
    }

    zone_name(zone_no) {
        return this.props.thermostat_zones_settings?.[zone_no]?.name;
    }

    thermometer_by_slot(slot) {
        for (const therm of this.props.thermometers)
            if (therm.is_assigned_to_slot && therm.slot === slot) return therm;
        return null;
    }

    control_thermometer(zone_no, mode_no = null) {
        if (zone_no === 0) return null;

        if (mode_no == null) mode_no = this.props.thermostat_ext_mode;

        const mode = this.props.thermostat_ext_modes_config?.[mode_no];
        if (mode?.schedule_number != null && this.props.tempschedule?.week != null) {
            const day_no =
                2 <= mode.schedule_number && mode.schedule_number <= 8
                    ? mode.schedule_number - 2
                    : (new Date().getDay() + 6) % 7;
            const hour = (new Date().getUTCHours() + this.props.timezone) % 24;
            const cell = this.props.tempschedule.week[day_no]?.[hour];
            if (cell?.startsWith?.('M')) {
                const schedule_mode_no = parseInt(cell[1], 10);
                if (
                    schedule_mode_no &&
                    !isNaN(schedule_mode_no) &&
                    schedule_mode_no !== mode_no
                )
                    return this.control_thermometer(zone_no, schedule_mode_no);
            }
        }

        const zone_sensor_slot = mode?.zone_sensors?.[zone_no];
        if (zone_sensor_slot != null) {
            const therm = this.thermometer_by_slot(zone_sensor_slot);
            if (therm != null) return therm;
        }

        for (const therm of this.props.thermometers)
            if (therm.is_assigned_to_slot)
                for (const func of therm.functions ?? [])
                    if (func.f === 'control' && func.zone === zone_no) return therm;

        return null;
    }

    current_dhw_temp() {
        const otzones = this.props.otzones_last;
        if (otzones != null) {
            const dts = new Array(this.props.ot_zones_count)
                .fill(0)
                .map((_, i) => otzones[i]?.dt)
                .filter((x) => x != null);
            if (dts.length > 0) return Math.max(...dts);
            return null;
        } else {
            return this.props.last_boiler_state?.ot?.dt;
        }
    }

    current_dhw_flame() {
        const otzones = this.props.otzones_last;
        if (otzones != null) {
            for (let i = 0; i < this.props.ot_zones_count.length; i++)
                if ((otzones[i].s ?? []).includes('dhw')) return true;
            return false;
        } else return (this.props.last_boiler_state?.ot?.s ?? []).includes('dhw');
    }

    on_inc_dec = (zone_id, delta1) => {
        if (this.props.is_guest) return;

        const temps = this.props.thermostat_target_temps;
        if (temps?.[zone_id] == null) return;
        if (temps[zone_id].off) return;
        if (temps[zone_id].temp == null) return;

        this.props.onSetTargetTemps(this.props.device_id, {
            ...temps,
            [zone_id]: {
                temp: temps[zone_id].temp + this.props.tempstep * delta1,
                manual: true,
            },
        });
    };

    on_cascade_select = (zone_id, value) => {
        if (this.props.is_guest) return;

        const temps = this.props.thermostat_target_temps;
        if (temps[zone_id] == null) return;

        const update =
            value === 'off' ? {off: true, cascade: null} : {off: false, cascade: value};

        this.props.onSetTargetTemps(this.props.device_id, {
            ...temps,
            [zone_id]: {
                ...temps[zone_id],
                manual: true,
                ...update,
            },
        });
    };

    render() {
        const target_temps = this.props.thermostat_target_temps ?? {};
        const {last_boiler_state} = this.props;
        const last_zone_state = last_boiler_state?.zones ?? {};

        let zone_count = 0;
        for (const zone_id of Object.keys(target_temps || {})) zone_count++;

        const show_dhw =
            this.props.ot_enabled &&
            this.props.ot_config &&
            this.props.ot_config.includes('dhw');

        const tempprops = [];
        for (let [zone_id, zone_spec] of Object.entries(target_temps || {})) {
            zone_id = ~~zone_id;
            if (zone_id === 0 && !show_dhw) continue;
            const temp_limit_max =
                this.props.thermostat_temps_limits?.[zone_id]?.['max'] ?? +300;
            const temp_limit_min =
                this.props.thermostat_temps_limits?.[zone_id]?.['min'] ?? -300;
            const control_therm = this.control_thermometer(zone_id);

            tempprops.push({
                key: zone_id,
                //is_guest: @props.is_guest
                adjustable:
                    !this.props.is_guest && !zone_spec.off && zone_spec.cascade == null,
                id: zone_id,
                spec: zone_spec,
                name: this.props.thermostat_zones_settings?.[zone_id]?.name,
                target_therm_name: this.target_therm_name(zone_id, zone_count),
                flame:
                    zone_id === 0
                        ? this.current_dhw_flame()
                        : last_zone_state[zone_id]?.worktime > 0,
                current_temp:
                    zone_id === 0
                        ? this.current_dhw_temp()
                        : control_therm?.last_state === 'ok'
                        ? control_therm.last_value
                        : null,
                zone_settings: this.props.thermostat_zones_settings?.[zone_id],
                zone_count,
                temp_warn_inc:
                    zone_spec.temp >= temp_limit_max
                        ? 'Установлена максимальная температура'
                        : undefined,
                temp_warn_dec:
                    zone_spec.temp <= temp_limit_min
                        ? 'Установлена минимальная температура'
                        : undefined,

                onIncDecClick: (delta) => this.on_inc_dec(zone_id, delta),
                onCascadeSelect: (cascade_value) =>
                    this.on_cascade_select(zone_id, cascade_value),
            });
        }

        tempprops.sort((a, b) => {
            if (a.id === 0) return +1; // DHW should be last
            if (b.id === 0) return -1;
            if (a.id < b.id) return -1;
            if (a.id > b.id) return +1;
            return 0;
        });

        return (
            <div className="thermostat-target-temp-container-2">
                {tempprops.map((props) => (
                    <TargetTemp {...props} />
                ))}
            </div>
        );
    }
}

export const TargetTempsControl = connect(
    (state, {device_id}) => {
        const r_device = selectDevice(state, device_id);

        return {
            is_guest: state.account.is_guest,
            thermostat_target_temps: r_device.thermostat_target_temps,
            ot_enabled: r_device.ot_enabled,
            ot_config: r_device.ot_config,
            last_boiler_state: r_device.last_boiler_state,
            thermometers: r_device.thermometers,
            thermostat_ext_modes_config: r_device.thermostat_ext_modes_config,
            thermostat_ext_mode: r_device.thermostat_ext_mode,
            thermostat_zones_settings: r_device.thermostat_zones_settings,
            otzones_last: r_device.otzones_last,
            ot_zones_count: r_device.ot_zones_count,
            tempschedule: r_device.tempschedule,
            tempstep: r_device.tempstep,
            timezone: r_device.timezone ?? 3,
            thermostat_temps_limits: r_device.thermostat_temps_limits,

            temp_limits_kapitanhotel: [1, 40174].includes(state.account.id),
        };
    },

    {
        onSetTargetTemps: requestThermostatZoneTemps,
    }
)(TargetTempsControlImpl);

const TargetTempsControlCard = (props) => {
    const target_temps = props.thermostat_target_temps ?? {};
    const show_dhw =
        props.ot_enabled && props.ot_config && props.ot_config.includes('dhw');

    const count = Object.keys(target_temps ?? {}).filter(
        (k) => k !== '0' || show_dhw
    ).length;

    return (
        <div
            className={classnames('ui-card', 'thermostat-target-temps', {
                'thermostat-target-temps-multi': count > 1,
            })}
        >
            <h1 style={{textAlign: 'left'}}>Целевая температура</h1>
            <TargetTempsControl {...props} />
        </div>
    );
};

class ThermostatExtControlImpl extends React.Component {
    constructor(props) {
        super(...arguments);

        this.state = {
            offline_errbox_shown: false,
        };
    }

    on_gate_changed = (checked) => {
        if (this.props.is_guest) return;

        this.props.onRequestDeviceUpdate(
            this.props.r_device.id,
            {thermostat_gate: checked},
            {ignore_server_response: true, obey_only_last_response: true}
        );
        if (!this.props.r_device.online) this._showOfflineErrbox();
    };

    on_dhw_changed = (dhw_enabled) => {
        if (this.props.is_guest) return;

        const config = this.props.r_device.ot_config;
        if (config == null) return;

        const flags = Object.fromEntries(config.map((flag) => [flag, true]));

        if (dhw_enabled) flags['dhw'] = true;
        else delete flags['dhw'];

        this.props.onRequestDeviceUpdate(
            this.props.r_device.id,
            {ot_config: Object.keys(flags)},
            {ignore_server_response: true, obey_only_last_response: true}
        );
        if (!this.props.r_device.online) this._showOfflineErrbox();
    };

    _showOfflineErrbox() {
        this.setState({offline_errbox_shown: true});
    }

    on_set_mode = (mode_id) => {
        if (this.props.is_guest) return;

        this.props.onRequestDeviceUpdate(
            this.props.r_device.id,
            {
                thermostat_ext_mode: mode_id,
                thermostat_gate: false,
            },
            {ignore_server_response: true, obey_only_last_response: true}
        );
        if (!this.props.r_device.online) this._showOfflineErrbox();
    };

    render() {
        const {active, server_time, r_device} = this.props;

        return (
            <div className="thermostat-ext-control">
                {(this.props.r_device.last_boiler_state?.fail ?? false) && (
                    <div style={{textAlign: 'center'}}>
                        <div style={{display: 'inline-block'}}>
                            <BoilerFailPane
                                fail={
                                    this.props.r_device.last_boiler_state?.fail ?? false
                                }
                                single_ot={this.props.r_device.last_boiler_state?.ot}
                                multi_ot={this.props.r_device.otzones_last}
                                ot_zones_count={this.props.r_device.ot_zones_count}
                                ot_boiler_type={this.props.r_device.ot_boiler_type}
                            />
                        </div>
                    </div>
                )}
                <div
                    className="ui-cards-container"
                    style={{maxWidth: '1024px', width: '100%'}}
                >
                    <TargetTempsControlCard device_id={this.props.r_device.id} />
                    <ThermostatExtModesControl
                        device_id={this.props.r_device.id}
                        onGateChanged={this.on_gate_changed}
                        onDHWChanged={this.on_dhw_changed}
                        onModeChanged={this.on_set_mode}
                    />
                </div>

                <MessageBox
                    open={this.state.offline_errbox_shown}
                    onClose={() => this.setState({offline_errbox_shown: false})}
                    title="Термостат не на связи"
                >
                    <p>Режим будет изменён когда термостат выйдет на связь</p>
                    <ButtonBox>
                        <button
                            onClick={() => this.setState({offline_errbox_shown: false})}
                        >
                            OK
                        </button>
                    </ButtonBox>
                </MessageBox>
            </div>
        );
    }
}

const ThermostatExtControl = connect(null, {
    onSetTargetTemps: requestThermostatZoneTemps,
    onRequestDeviceUpdate: requestDeviceUpdate,
})(ThermostatExtControlImpl);

const ThermostatExtControlTabImpl = ({r_device, active, server_time, is_guest}) => (
    <div className="ui-thermostat-control-tab-content">
        <ThermostatExtControl
            r_device={r_device}
            active={active}
            server_time={server_time}
            is_guest={is_guest}
        />

        <div className="ui-cards-container thermostat-ext-control-temps-container">
            <div className="ui-card thermostat-ext-control-temps-card">
                <h1>Температура</h1>
                <DeviceThermometersView r_device={r_device} server_time={server_time} />
            </div>
        </div>
    </div>
);

export const ThermostatExtControlTab = connect((state) => ({
    server_time: state.server_time,
    is_guest: state.account.is_guest,
    r_device: selectSelectedDevice(state),
}))(ThermostatExtControlTabImpl);

ThermostatExtControlTab.should_appear_depends_on = [
    'device_type',
    'capabilities',
    'thermostat_enabled',
    'access',
    'firmware_version',
];
ThermostatExtControlTab.should_appear = (device, account, r_device) =>
    LegacyDevice.has_access(account.id(), r_device, 'view_state') &&
    LegacyDevice.supports_thermostat_ext_modes(r_device) &&
    (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_thermostat) ||
        (LegacyDevice.has_capability(
            r_device?.capabilities,
            Capability.has_optional_thermostat
        ) &&
            r_device.thermostat_enabled));

export const thermostatExtTabDefinition = {
    key: 'thermostat-ext',
    title: 'отопление',
    iconclass: 'ui-icon-tab-temperature',
    should_appear_depends_on: ThermostatExtControlTab.should_appear_depends_on,
    should_appear: ThermostatExtControlTab.should_appear,
    render: ThermostatExtControlTab,
};
